import { React, useState } from 'react';
import '../../App.css';
import { Grid, TextField, Box, Button, Paper, Typography } from '@mui/material';
import { CurrencyRupee } from '@mui/icons-material';
import { FaHandHolding } from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function GratuityReport() {
  const [baseDate, setBaseDate] = useState('');
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    const temp = {};
    temp.baseDate = baseDate ? '' : 'This field is required.';
    setErrors(temp);
    return Object.values(temp).every((x) => x === '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/report/get-gratuity-report`,
        { base_date: baseDate }
      );
      navigate('/gratuity-report-generated', {
        state: { reportData: response.data, baseDate },
      });
    } catch (error) {
      const status = error?.response?.status;
      const msg =
        error?.response?.data?.error_message ||
        'Failed to fetch gratuity report. Please try again.';
      setNotify({ isOpen: true, message: msg, type: 'error' });
      if (status === 401) {
        setTimeout(() => navigate('/'), 1000);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        padding: '50px',
        fontWeight: '500px',
      }}
    >
      <Paper elevation={5} sx={{ width: '1000px', height: '210px' }}>
        <Grid
          className="form-title"
          container
          spacing={2}
          justifyContent="center"
          style={{ marginTop: '15px' }}
          alignItems="center"
        >
          <Grid item>
            <Box sx={{ position: 'relative', width: 45, height: 45, display: 'inline-flex' }}>
              <FaHandHolding size={32} style={{ position: 'absolute', left: 2, bottom: 4 }} />
              <CurrencyRupee sx={{ fontSize: 18, position: 'absolute', right: 2, top: 2 }} />
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="h5">Gratuity Report</Typography>
          </Grid>
        </Grid>

        <form autoComplete="off" onSubmit={handleSubmit}>
          <Box sx={{ margin: '30px' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: 2,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                label={<RequiredLabel label="Base Date" />}
                name="baseDate"
                value={baseDate}
                onChange={(e) => {
                  setBaseDate(e.target.value);
                  if (errors.baseDate) setErrors({ ...errors, baseDate: '' });
                }}
                sx={{ width: '220px' }}
                InputLabelProps={{ shrink: true }}
                size="small"
                error={!!errors.baseDate}
                helperText={errors.baseDate}
              />

              <Button
                className="form-btn"
                color="success"
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{ height: 40 }}
              >
                {loading ? 'Loading...' : 'Display'}
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default GratuityReport;
